export function isAxiosError(error: any): boolean {
  return (
    error !== null && typeof error === 'object' && error.isAxiosError === true
  );
}
